/* eslint-disable react-hooks/exhaustive-deps */
import 'videojs-contrib-quality-levels'

import 'react-toastify/dist/ReactToastify.css'
import 'videojs-seek-buttons/dist/videojs-seek-buttons.css'
import 'video.js/dist/video-js.css'

import './styles/vjs-styles.css'

import { ApiInterceptor } from './services/api'

import { Router } from 'react-router-dom'

import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'

import { store, persistor } from './store'
import { DarkThemeProvider, TimerDataProvider } from './providers'
import TrackingMiddleware from './tracking'
import { useTracking } from 'react-tracking'

import history from './services/history'
import Routes from './routes'

import CookieBar from './components/Cookiebar'
import ModalLogin from './components/ModalLogin'
import Timer from './components/Timer'

import { GlobalStyle } from './styles/global'

import { StartupLogic } from './services/startupLogic'
import ToastContainer from './components/ToastContainer'
import SWRConfig from './providers/SWRConfig'

function App() {
  const { Track } = useTracking(
    { app: TrackingMiddleware.app },
    { dispatch: TrackingMiddleware.dispatch }
  )

  return (
    <Router history={history}>
      <Provider store={store}>
        <Track>
          <PersistGate persistor={persistor}>
            <ModalLogin />

            <StartupLogic />
            <ApiInterceptor />

            <DarkThemeProvider>
              <SWRConfig>
                <TimerDataProvider>
                  <GlobalStyle />
                  <ToastContainer />
                  <CookieBar />
                  <Timer />
                  <Routes />
                </TimerDataProvider>
              </SWRConfig>
            </DarkThemeProvider>
          </PersistGate>
        </Track>
      </Provider>
    </Router>
  )
}

export default App
